import store from '~/store'
import Swal from 'sweetalert2'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})

export default (to, from, next) => {
  if (!store.getters['auth/user'].admin) {
    Toast.fire({
      icon: 'error',
      title: 'You cannot access this section'
    })

    next({ name: 'home' })
  } else {
    next()
  }
}
